import { postJob, postJobs } from "./jobActions";
import { postResults, signaltekPostResults } from "./resultActions";
import { treeview } from "./treeviewActions";
import Notify from "./notifyActions";
import { getPresetDefaultColumns } from "../../common/tabletools";

export const TESTS_METADATA_STANDARDS = "TESTS_METADATA_STANDARDS";
export const testsMetadataStandards = () => ({
  type: TESTS_METADATA_STANDARDS,
  payload: {
    request: {
      url: "group",
      method: "GET"
    }
  }
});

export const FIBER_TESTS_METADATA_STANDARDS = "FIBER_TESTS_METADATA_STANDARDS";
export const fiberTestsMetadataStandards = () => ({
  type: FIBER_TESTS_METADATA_STANDARDS,
  payload: {
    request: {
      url: "createfibertest",
      methos: "GET"
    }
  }
});

export const FIBER_TEST_UPDATE = "FIBER_TEST_UPDATE";
export const FIBER_TEST_UPDATE_SUCCESSFULL_TOAST =
  "fiber_test_update_successfull_taost";
export const FIBER_TEST_UPDATE_UNSUCCESSFULL_TOAST =
  "fiber_test_update_unsuccessfull_taost";
 
export const fiberTestUpdate = (test, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: FIBER_TEST_UPDATE,
        payload: {
          request: {
            url: "fibertest",
            method: "PUT",
            data: { request: test }
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            dispatch(Notify.success(TEST_UPDATE_SUCCESSFULL_TOAST));
            dispatch(postJob(test.jobid));
            dispatch(testsList(pager, test.jobid));
            dispatch(testsReset());
            resolve();
          } else {
            reject(response.payload.data.errors);
          }
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  };
};

export const TESTS_RESET = "TESTS_RESET";
export const testsReset = () => ({
  type: TESTS_RESET
});

export const JOB_TESTS_RESET = "JOB_TESTS_RESET";
export const jobTestsReset = () => ({
  type: JOB_TESTS_RESET
});

export const TESTS_SAVE = "TESTS_SAVE";
export const TEST_CREATE_SUCCESSFULL_TOAST = "test_create_successfull_taost";
export const testsSave = (test, pager) => {
  return (dispatch, getState) => {
    dispatch({
      type: TESTS_SAVE,
      payload: {
        request: {
          url: "test",
          method: "POST",
          data: { request: test }
        }
      }
    })
      .then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TEST_CREATE_SUCCESSFULL_TOAST));
          dispatch(postJob(test.jobid));
          dispatch(testsList(pager, test.jobid));
          dispatch(testsReset());
        }
      })
      .catch(err => console.log(err));
  };
};

export const TESTS_FIBER_SAVE = "TESTS_FIBER_SAVE";
export const TEST__CREATE_SUCCESSFULL_TOAST = "test_create_successfull_taost";
export const testsFiberSave = (test, pager) => {
  return (dispatch, getState) => {
    dispatch({
      type: TESTS_FIBER_SAVE,
      payload: {
        request: {
          url: "CreateFiberTest",
          method: "POST",
          data: { ...test }
        }
      }
    })
      .then(response => {
        if (response.payload.data && response.payload.data.success) {
          dispatch(Notify.success(TEST_CREATE_SUCCESSFULL_TOAST));
          dispatch(postJob(test.jobid));
          dispatch(testsList(pager, test.jobid));
          dispatch(testsReset());
        }
      })
      .catch(err => console.log(err));
  };
};

export const TESTS_LIST = "TESTS_LIST";
export const testsList = (pager, jobid) => ({
  type: TESTS_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: `testlist?jobid=${jobid}`,
      method: "POST",
      data: pager,
      jobid
    }
  }
});

export const TESTS_CLEAR_SMART_FLAG_STATUSES = "TESTS_CLEAR_SMART_FLAG_STATUSES";
export const clearTestSmartFlagStatuses = () => ({
  type: TESTS_CLEAR_SMART_FLAG_STATUSES
});

export const TEST_GET = "TEST_GET";
export const getTest = testid => ({
  type: TEST_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `test?testid=${testid}`,
      method: "GET"
    }
  }
});

export const FIBER_TEST_GET = "FIBER_TEST_GET";
export const getFiberTest = testid => ({
  type: FIBER_TEST_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `fibertest?testid=${testid}`,
      method: "GET"
    }
  }
});

export const TEST_UPDATE = "TEST_UPDATE";
export const TEST_UPDATE_SUCCESSFULL_TOAST = "test_update_successfull_taost";
export const TEST_UPDATE_UNSUCCESSFULL_TOAST =
  "test_update_unsuccessfull_taost";

export const testUpdate = (test, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TEST_UPDATE,
        payload: {
          request: {
            url: "test",
            method: "PUT",
            data: { request: test }
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            dispatch(Notify.success(TEST_UPDATE_SUCCESSFULL_TOAST));
            dispatch(postJob(test.jobid));
            dispatch(testsList(pager, test.jobid));
            dispatch(testsReset());
            resolve();
          } else {
            reject(response.payload.data.errors);
          }
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  };
};

export const TEST_RECERT = "TEST_RECERT";
export const TEST_RECERT_SUCCESSFULL_TOAST = "test_recert_successfull_taost";
export const TEST_RECERT_UNSUCCESSFULL_TOAST =
  "test_recert_unsuccessfull_toast";
export const TEST_RECERT_MAX_COUNT_EXCEEDED_TOAST =
  "test_recert_max_count_exceeded_toast";

export const testRecert = (test, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TEST_RECERT,
        payload: {
          request: {
            url: "RecertifyTest",
            method: "POST",
            data: { request: test }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TEST_RECERT_SUCCESSFULL_TOAST));
          dispatch(postJob(test.jobid));
          dispatch(testsList(pager, test.jobid));
          dispatch(testsReset());
          resolve();
        } else {
          let errorText = response.payload.data.errors;
          if (errorText.startsWith("max_recertifycount_exceeded")) {
            let errorParts = errorText.split(":");
            let maxLimit = "200";
            if (errorParts.length >= 2) {
              maxLimit = errorParts[1];
            }
            dispatch(Notify.error(TEST_RECERT_MAX_COUNT_EXCEEDED_TOAST, { value: maxLimit }));
          }
          else {
            dispatch(Notify.error(TEST_RECERT_UNSUCCESSFULL_TOAST));
          }
          reject(response.payload.data.errors);
        }
      });
    });
  };
};

export const TESTS_SELECTED = "TESTS_SELECTED";
export const testsSelected = tests => ({
  type: TESTS_SELECTED,
  data: tests
});

export const TESTS_MOVE = "TESTS_MOVE";
export const TESTS_MOVE_SUCCESSFULL_TOAST = "tests_move_successfull_taost";
export const TESTS_MOVE_UNSUCCESSFULL_TYPE_TOAST =
  "tests_move_unsuccessfull_type_taost";

export const testsMove = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TESTS_MOVE,
        payload: {
          request: {
            mode: "no-cors",
            url: "movetest",
            method: "POST",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TESTS_MOVE_SUCCESSFULL_TOAST));
          dispatch(testsList(pager, data.jobid));
          dispatch(testsSelected(null));
          dispatch(postJob(data.jobid));
          resolve(response.payload);
        } else {
          if (response.payload.data.errors === "error_no_permission") {
            dispatch(Notify.error(TESTS_MOVE_UNSUCCESSFULL_TYPE_TOAST));
            reject(response.payload);
          }
        }
      });
    });
  };
};

export const TESTS_DELETE = "TESTS_DELETE";
export const TESTS_DELETE_SUCCESSFULL_TOAST = "tests_delete_successfull_taost";
export const testsDelete = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TESTS_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: "test",
            method: "DELETE",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TESTS_DELETE_SUCCESSFULL_TOAST));
          dispatch(testsList(pager, data.jobid));
          dispatch(testsSelected(null));
          dispatch(postJob(data.jobid));
          resolve(response.payload);
        }
      });
    });
  };
};

export const TESTS_LIST_SAVE_PREFERENCES = "TESTS_LIST_SAVE_PREFERENCES";
export const savePreferences = (pager, columns, preferencesSaved, updatePreset = false) => {
  return (dispatch, getState) => {
    const visibleColumns = columns.filter(x => x.show).map(x => x.id);
    dispatch({
      type: TESTS_LIST_SAVE_PREFERENCES,
      data: {
        pager,
        columns,
        visibleColumns,
        preferencesSaved
      }
    });

    // When using toggleColumn functionality, persist preset
    if (updatePreset === true){
      dispatch({
        type: TESTS_LIST_UPDATE_COLUMN_PRESET,
        payload: {
          request: {
            mode: "no-cors",
            url: "column-presets/" + encodeURIComponent(getState().testsReducer.columnPreset),
            method: "PUT",
            data: {request: visibleColumns}
          }
        }
      }).then(_ => {
        // We could optionally display success toast
      });
    }
  }
};

// Load all Column Presets, so we can cache it in store
export const TESTS_LIST_LOAD_COLUMN_PRESETS = "TESTS_LIST_LOAD_COLUMN_PRESETS";
export const TESTS_LIST_COLUMN_PRESETS_LOADED =  "TESTS_LIST_COLUMN_PRESETS_LOADED";
export const loadColumnPresets = () => {
  return (dispatch, getState) => {
    const presetColumns = getState().testsReducer.columnPresets;
    if (presetColumns){
      // Presets already loaded
      return;
    }

    dispatch({
      type: TESTS_LIST_LOAD_COLUMN_PRESETS,
      payload: {
        request: {
          mode: "no-cors",
          url: "column-presets",
          method: "GET",
        },
      },
    }).then((response) => {
      dispatch({
        type: TESTS_LIST_COLUMN_PRESETS_LOADED,
        data: {
          presets: response.payload.data,
        },
      });
    });
  };
};

// Triggered by TESTS_LIST_SAVE_PREFERENCES, persist Column Preset in DB
export const TESTS_LIST_UPDATE_COLUMN_PRESET = "TESTS_LIST_UPDATE_COLUMN_PRESET";
export const updateColumnPreset = (preset, columns) => {
  return (dispatch, _) => {
    dispatch({
      type: TESTS_LIST_UPDATE_COLUMN_PRESET,
      payload: {
        request: {
          mode: "no-cors",
          url: "column-presets/" + encodeURIComponent(preset),
          method: "PUT",
          data: { request: columns }
        }
      }
    }).then(_ => {
      // We could optionally display success toast
    });
  }
}

export const TESTS_LIST_COLUMN_PRESET_SELECTED =  "TESTS_LIST_COLUMN_PRESET_SELECTED";
export const selectColumnPreset = (preset) => {
  return (dispatch, getState) => {
    // Check if preset is new - user using it for the first time
    const newPreset = !getState().testsReducer.columnPresets[preset];
    const presetColumns = getState().testsReducer.columnPresets[preset] || [];
    const defaultColumns = getPresetDefaultColumns(preset);

    const pager = getState().testsReducer.preferences ? getState().testsReducer.preferences.pager : null;
    const preferencesSaved =  getState().testsReducer.preferences ? getState().testsReducer.preferencesSaved : null;
    const cols = getState().testsReducer.preferences ?  getState().testsReducer.preferences.columns : null ;

    if (cols && presetColumns && presetColumns.length > 0){
      cols.forEach((col) => {
        col.show = presetColumns.includes(col.id); 
      });
    } else if (cols) {
      cols.forEach((col) => {
        col.show = defaultColumns.includes(col.id);
      });
    }
    dispatch({
      type: TESTS_LIST_COLUMN_PRESET_SELECTED,
      data: {
        columns: cols,
        pager: pager,
        preferencesSaved: preferencesSaved,
        preset: preset,
      },
    });

    if (newPreset){
      // Persist default layout for user/preset
      dispatch(updateColumnPreset(preset, defaultColumns));
    }
  };
};


export const TESTS_GENERATE_REPORT = "TESTS_GENERATE_REPORT";
export const TESTS_GENERATE_REPORT_SUCCESSFULL_TOAST =
  "tests_generate_report_successfull_toast";
export const TESTS_GENERATE_REPORT_UNSUCCESSFULL_TOAST =
  "tests_generate_report_unsuccessfull_toast";
export const TESTS_GENERATE_REPORT_NO_TEST_TOAST =
  "tests_generate_report_no_test_toast";
export const TEST_REPORT_MAX_COUNT_EXCEEDED_TOAST =
  "brief_report_too_many_tests";
export const generateReport = data => {
  return (dispatch, getState) => {
    dispatch({
      type: TESTS_GENERATE_REPORT,
      payload: {
        request: {
          mode: "no-cors",
          url: "Report",
          method: "POST",
          data: { request: data }
        }
      }
    }).then(response => {
      if (response.payload.data.success) {
        dispatch(Notify.success(TESTS_GENERATE_REPORT_SUCCESSFULL_TOAST));
      } else {
        if (response.payload.data.errors === "error_notest") {
          dispatch(Notify.error(TESTS_GENERATE_REPORT_NO_TEST_TOAST));
        }
        else {
          let errorText = response.payload.data.errors;
          if (errorText.startsWith("max_reportcount_exceeded")) {
              let errorParts = errorText.split(":");
              let maxLimit = "1000";
              if (errorParts.length >= 2) {
                maxLimit = errorParts[1];
              }
              dispatch(Notify.error(TEST_REPORT_MAX_COUNT_EXCEEDED_TOAST, { value: maxLimit }));
          }
          else {
            dispatch(
              Notify.error(TESTS_GENERATE_REPORT_UNSUCCESSFULL_TOAST, {
                errors: response.payload.data.errors
              })
            );
          }
        }
      }
    });
  };
};

export const TEST_SUSPICIOUSFILTER = "TEST_SUSPICIOUSFILTER";
export const TEST_SUSPICIOUSFILTER_SUCCESSFULL_TOAST =
  "test_suspicious_successfull_taost";
export const TEST_SUSPICIOUSFILTER_UNSUCCESSFULL_TOAST =
  "test_suspicious_unsuccessfull_taost";

export const activateSuspiciousFilter = (jobId, pager) => {
  return (dispatch, getState) => {
    dispatch({
      type: TEST_SUSPICIOUSFILTER,
      payload: {
        request: {
          mode: "no-cors",
          url: `SuspiciousCheck?jobid=${jobId}`,
          method: "POST"
        }
      }
    }).then(response => {
      if (response.payload.data.success) {
        dispatch(Notify.success(TEST_SUSPICIOUSFILTER_SUCCESSFULL_TOAST));
        dispatch(postJob(jobId));
        dispatch(testsList(pager, jobId));
      } else {
        dispatch(Notify.success(TEST_SUSPICIOUSFILTER_UNSUCCESSFULL_TOAST));
      }
    });
  };
};

export const JOB_TEST_ATTACHMENTS = "JOB_TEST_ATTACHMENTS";
export const getAttachments = (jobid, testid) => {
  let url = `Attachment?jobid=${jobid}`;
  if (testid) url += `&testid=${testid}`;

  return (dispatch, getState) => {
    dispatch({
      type: JOB_TEST_ATTACHMENTS,
      payload: {
        request: {
          mode: "no-cors",
          url: url,
          method: "GET"
        }
      }
    });
  };
};

export const JOBS_TESTS_UPLOAD_FILE = "JOBS_TESTS_UPLOAD_FILE";
export const JOBS_TESTS_UPLOAD_FILE_SUCCESSFULL_TOAST =
  "jobs_tests_upload_file_successfull_toast";
export const JOBS_TESTS_UPLOAD_FILE_UNSUCCESSFULL_TOAST =
  "jobs_tests_upload_file_unsuccessfull_toast";

export const uploadAttachment = (data, jobid, testid, cid) => {
  data.append("jobid", jobid);
  let params = {
    jobid
  };
  if (testid) {
    params = {
      ...params,
      testid
    };
    data.append("testid", testid);
  }

  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: JOBS_TESTS_UPLOAD_FILE,
        payload: {
          request: {
            url: "Attachment",
            method: "POST",
            headers: {
              "content-type": "multipart/form-data"
            },
            data: data
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            let searchParams = JSON.parse(
              sessionStorage.getItem("JOB_SEARCH_PARAMS")
            );
            dispatch(Notify.success(JOBS_TESTS_UPLOAD_FILE_SUCCESSFULL_TOAST));
            dispatch(getAttachments(jobid, testid));
            if (window.location.href.includes("job")) {
              dispatch(
                postJobs(
                  searchParams ? [...searchParams.tempSearch] : [],
                  1,
                  15,
                  cid,
                  getState().jobReducer.jobsDefaultOrder
                )
              );
            } else {
              if (getState().resultReducer.isSignaltek) {
                dispatch(
                  signaltekPostResults(jobid, testid, getState().testsReducer.filters)
                );
              }
              else {
                dispatch(
                  postResults(jobid, testid, getState().testsReducer.filters)
                );
              }
            }
            resolve();
          } else {
            dispatch(Notify.error(JOBS_TESTS_UPLOAD_FILE_UNSUCCESSFULL_TOAST));
            reject(response.payload.data.errors);
          }
        })
        .catch(error => {
          reject();
        });
    });
  };
};

export const ATTACHMENT_DELETE = "ATTACHMENT_DELETE";
export const ATTACHMENT_DELETE_SUCCESSFULL_TOAST =
  "attachment_delete_successfull_toast";
export const deleteAttachment = (file, cid) => {
  let url = `Attachment/${file.id}`;
  // if (file.testid)
  //   url += `&testid=${file.testid}`

  // url += `&fileName=${file.name}`
  return (dispatch, getState) => {
    dispatch({
      type: ATTACHMENT_DELETE,
      payload: {
        request: {
          url: url,
          method: "DELETE"
        }
      }
    })
      .then(response => {
        if (response.payload.data.success) {
          let searchParams = JSON.parse(
            sessionStorage.getItem("JOB_SEARCH_PARAMS")
          );
          dispatch(Notify.success(ATTACHMENT_DELETE_SUCCESSFULL_TOAST));

          if (window.location.href.includes("job")) {
            dispatch(
              postJobs(
                searchParams ? [...searchParams.tempSearch] : [],
                1,
                15,
                cid,
                getState().jobReducer.jobsDefaultOrder
              )
            );
          } else {
            if (getState().resultReducer.isSignaltek) {
              dispatch(
                signaltekPostResults(
                  file.jobid,
                  file.testid,
                  getState().testsReducer.filters
                )
              );
            }
            else {
              dispatch(
                postResults(
                  file.jobid,
                  file.testid,
                  getState().testsReducer.filters
                )
              );
            }
          }
        }
        dispatch(getAttachments(file.jobid, file.testid));
      })
      .catch(error => {});
  };
};

export const ATTACHMENT_DOWNLOAD = "ATTACHMENT_DOWNLOAD";
export const attachmentDownload = file => {
  let url = `Attachment/Download/${file.id}`;
  // if (file.testid)
  //   url += `&testid=${file.testid}`

  // url += `&filename=${encodeURIComponent(file.name)}`
  return (dispatch, getState) => {
    dispatch({
      type: ATTACHMENT_DOWNLOAD,
      payload: {
        request: {
          url: url,
          method: "POST"
        }
      }
    }).then(resp => {
      if (resp.payload.data) {
        window.open(resp.payload.data);
      }
    });
  };
};

export const RESET_RESULTS = "RESET_RESULTS";
export const resetResultsState = () => {
  return {
    type: RESET_RESULTS
  };
};

export const CLEAR_ATTACHMENTS = "CLEAR_ATTACHMENTS";
export const clearAttachments = () => ({
  type: CLEAR_ATTACHMENTS
});

export const CLEAR_ERRORS_VALUES = "CLEAR_ERRORS_VALUES";
export const clearErrors = () => ({
  type: CLEAR_ERRORS_VALUES
});

export const SIGNALTEK10G_TESTS_LIST = "SIGNALTEK10G_TESTS_LIST";
export const signaltek10gTestList = (pager, jobid) => ({
  type: SIGNALTEK10G_TESTS_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: `SignalTekTestList?jobid=${jobid}`,
      method: "POST",
      data: pager,
      jobid
    }
  }
});

export const TESTS_SIGNALTEK_SAVE = "TESTS_SIGNALTEK_SAVE";
//export const TEST__CREATE_SUCCESSFULL_TOAST = "test_create_successfull_taost"
export const saveSignaltekNewTests = (test, pager) => {
  return (dispatch, getState) => {
    dispatch({
      type: TESTS_FIBER_SAVE,
      payload: {
        request: {
          url: "SignaltekTest",
          method: "POST",
          data: {
            request: test
          }
        }
      }
    })
      .then(response => {
        if (response.payload.data && response.payload.data.success) {
          dispatch(Notify.success(TEST__CREATE_SUCCESSFULL_TOAST));
          dispatch(postJob(test.jobid));
          dispatch(signaltek10gTestList(pager, test.jobid));
          dispatch(testsReset());
          dispatch(treeview(-1));
        }
      })
      .catch(err => console.log(err));
  };
};

export const TEST_SIGNALTEK_GET = "TEST_SIGNALTEK_GET";
//export const TEST__CREATE_SUCCESSFULL_TOAST = "test_create_successfull_taost"
export const getSignatek10gTest = testid => ({
  type: TEST_SIGNALTEK_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `SignaltekTest?testid=${testid}`,
      method: "GET"
    }
  }
});

export const TESTS_SIGNALTEK_UPDATE = "test_update_successfull_taost";
export const TESTS_SIGNALTEK_UPDATE_UNSUCCESSFULL_TOAST =
  "test_update_unsuccessfull_taost";

export const updateSignaltekTests = (test, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TEST_UPDATE,
        payload: {
          request: {
            url: "SignaltekTest",
            method: "PUT",
            data: {
              request: test
            }
          }
        }
      })
        .then(response => {
          if (response.payload && response.payload.data && response.payload.data.success) {
            dispatch(Notify.success(TESTS_SIGNALTEK_UPDATE));
            dispatch(postJob(test.jobid));
            dispatch(signaltek10gTestList(pager, test.jobid));
            dispatch(testsReset());
            resolve();
          } else {
            if(response.error.response.status===400){
              dispatch(Notify.error(TESTS_SIGNALTEK_UPDATE_UNSUCCESSFULL_TOAST));
            }else{
              dispatch(Notify.error(TESTS_SIGNALTEK_UPDATE_UNSUCCESSFULL_TOAST));
            }
            reject(response.payload.data.errors);
          }
        })
        .catch(err => console.log(err));
    });
  };
};

export const JOB_SEARCH_FILTER = "JOB_SEARCH_FILTER";
export const saveJobSearchFilter = (
  searchFilter,
  searchParams,
  jobSearchFilterSaved
) => {
  return {
    type: JOB_SEARCH_FILTER,
    data: {
      searchFilter,
      searchParams,
      jobSearchFilterSaved
    }
  };
};

export const signalTekTestsMove = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TESTS_MOVE,
        payload: {
          request: {
            mode: "no-cors",
            url: "movetest",
            method: "POST",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TESTS_MOVE_SUCCESSFULL_TOAST));
          dispatch(signaltek10gTestList(pager, data.jobid));
          dispatch(testsSelected(null));
          dispatch(postJob(data.jobid));
          resolve(response.payload);
        } else {
          if (response.payload.data.errors === "error_no_permission") {
            dispatch(Notify.error(TESTS_MOVE_UNSUCCESSFULL_TYPE_TOAST));
            reject(response.payload);
          }
        }
      });
    });
  };
};

export const signaltekTestsDelete = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TESTS_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: "test",
            method: "DELETE",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TESTS_DELETE_SUCCESSFULL_TOAST));
          dispatch(signaltek10gTestList(pager, data.jobid));
          dispatch(testsSelected(null));
          dispatch(postJob(data.jobid));
          resolve(response.payload);
        }
      });
    });
  };
};

export const JOB_USER_PREFERENCE = "JOB_USER_PREFERENCE";

export const getUserPreference = () => ({
  type: JOB_USER_PREFERENCE,
  payload: {
    request: {
      url: "Preference",
      method: "GET"
    }
  }
});

export const JOB_USER_PREFERENCE_SAVE = "JOB_USER_PREFERENCE_SAVE";
export const postUserPreference = (issignaltek, preferenceModel) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: JOB_USER_PREFERENCE_SAVE,
        payload: {
          request: {
            url: "Preference",
            method: "POST",
            data: {
              request: {
                issignaltek: issignaltek,
                preferenceModel: preferenceModel
              }
            }
          }
        }
      })
        .then(response => {
          //dispatch(postJob(jobid));
          resolve();
        })
        .catch(ex => {
          //dispatch(postJob(jobid));
          resolve();
        });
    });
  };
};
export const signaltekSubTestsDelete = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TESTS_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: "SignaltekTest",
            method: "DELETE",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(TESTS_DELETE_SUCCESSFULL_TOAST));
          dispatch(signaltek10gTestList(pager, data.jobid));
          dispatch(testsSelected(null));
          dispatch(postJob(data.jobid));
          resolve(response.payload);
        }
      });
    });
  };
};
